import type { GradeEquipmentType, GradeMotorizationType } from "../../../../common-deprecated/types/GradeType";
import type {
    ExtraType,
    ModelFilterDimensionType,
    ModelGradeType,
    PackType,
    ServiceProductType,
} from "../../../../common-deprecated/types/CommonTypes";
import type { FinanceInsuranceCalculatorType } from "./FinanceInsuranceCalculatorLink";
import type {
    IntegratedTradeInModalType,
    MODAL_INTEGRATED_TRADE_IN_AEM,
} from "../../../../shared-logic/features/tradein/utils/integratedModalConstants";
import type { BuildAndBuyLabelType } from "./labels";
import type {
    MODAL_RETAILER_DEBUG,
    MODAL_RETAILER_SHOW_TYCODE,
    RetailerDebugModalType,
    RetailerShowTyCodeModalType,
} from "../../../../shared-logic/features/retailer/utils/modalConstants";
import type { SortedSpecType } from "../../../../common-deprecated/types/SpecTypes";
import type {
    DetailedTyreInfoModalType,
    MODAL_DETAILED_TYRE_INFO,
} from "../../../../shared-logic/utils/tyreInfoContants";

export const MODAL_GRADE_EQUIPMENT = "gradeEquipment" as const;
export const MODAL_GRADE_INTERIOR = "gradeInterior" as const;
export const MODAL_ENGINE_DETAIL = "engineDetail" as const;
export const MODAL_FINANCE_INFO = "financeInfo" as const;
export const MODAL_FINANCE_CALCULATOR = "financeCalculator" as const;
export const MODAL_CONFIG_CODE = "configcode" as const;
export const MODAL_TRADEIN = "tradein" as const;
export const MODAL_BUY_TERMS = "buyTerms" as const;
export const MODAL_RESERVE_TERMS = "reserveTerms" as const;
export const MODAL_LEASE_TERMS = "leaseTerms" as const;
export const MODAL_WINTER_WHEELS = "winterWheels" as const;
export const MODAL_ALTERNATIVES_ETA = "alternativesETA" as const;
export const MODAL_PACK_CONFLICT = "packConflict" as const;
export const MODAL_EXTRA_CONFLICT = "extraConflict" as const;
export const MODAL_SERVICE_PRODUCT_CONFLICT = "serviceProductConflict" as const;
export const MODAL_MASS_MANAGEMENT = "massManagement" as const;
export const MODAL_EXIT_PASSIVE_SUMMARY = "exitPassiveSummary" as const;
export const MODAL_FINANCE_TOGGLE = "financeToggle" as const;
export const MODAL_PROACE = "proace" as const;
export const MODAL_LCV_DEBUG = "lcvDebug" as const;
export const MODAL_EXTRA_ONLY_PACK_SINGLE = "extraOnlyPackSingle" as const;
export const MODAL_EXTRA_ONLY_PACK_MULTIPLE = "extraOnlyPackMultiple" as const;

export type BnBModalIdsType =
    | typeof MODAL_PROACE
    | typeof MODAL_LCV_DEBUG
    | typeof MODAL_GRADE_EQUIPMENT
    | typeof MODAL_GRADE_INTERIOR
    | typeof MODAL_ENGINE_DETAIL
    | typeof MODAL_FINANCE_INFO
    | typeof MODAL_FINANCE_CALCULATOR
    | typeof MODAL_CONFIG_CODE
    | typeof MODAL_TRADEIN
    | typeof MODAL_BUY_TERMS
    | typeof MODAL_RESERVE_TERMS
    | typeof MODAL_LEASE_TERMS
    | typeof MODAL_WINTER_WHEELS
    | typeof MODAL_ALTERNATIVES_ETA
    | typeof MODAL_PACK_CONFLICT
    | typeof MODAL_EXTRA_CONFLICT
    | typeof MODAL_SERVICE_PRODUCT_CONFLICT
    | typeof MODAL_MASS_MANAGEMENT
    | typeof MODAL_EXIT_PASSIVE_SUMMARY
    | typeof MODAL_DETAILED_TYRE_INFO
    | typeof MODAL_FINANCE_TOGGLE
    | typeof MODAL_INTEGRATED_TRADE_IN_AEM
    | typeof MODAL_RETAILER_DEBUG
    | typeof MODAL_RETAILER_SHOW_TYCODE
    | typeof MODAL_EXTRA_ONLY_PACK_SINGLE
    | typeof MODAL_EXTRA_ONLY_PACK_MULTIPLE;

export type AlternativesETAModalType = {
    type: typeof MODAL_ALTERNATIVES_ETA;
};
export type BuyTermsModalType = {
    type: typeof MODAL_BUY_TERMS;
};
export type ReserveTermsModalType = {
    type: typeof MODAL_RESERVE_TERMS;
};
export type LeaseTermsModalType = {
    type: typeof MODAL_LEASE_TERMS;
};
export type EngineDetailsModalType = {
    type: typeof MODAL_ENGINE_DETAIL;
    motorization: GradeMotorizationType;
};
export type ExitPassiveSummaryModalType = {
    type: typeof MODAL_EXIT_PASSIVE_SUMMARY;
};
export type ExtraConflictModalType = {
    type: typeof MODAL_EXTRA_CONFLICT;
    extra: ExtraType;
    conflicts: ExtraType[];
    extraPendingStack: ExtraType[];
};
export type FinanceModalType = { type: typeof MODAL_FINANCE_INFO };
export type ConfigCodeModalType = {
    type: typeof MODAL_CONFIG_CODE;
};

export type FinanceCalculatorModalType = {
    type: typeof MODAL_FINANCE_CALCULATOR;
    calculatorType: FinanceInsuranceCalculatorType;
    title: BuildAndBuyLabelType;
    containerID: string;
    resetCalculator: () => void;
};

export type GradeEquipmentModalType = {
    type: typeof MODAL_GRADE_EQUIPMENT;
    gradeName: string;
    gradeSubtitle: string;
    modelName: string;
    mainFeatureEquipment: GradeEquipmentType[];
    listFeatureEquipment: SortedSpecType[];
};
export type GradeInteriorModalType = {
    type: typeof MODAL_GRADE_INTERIOR;
    grade: ModelGradeType;
};
export type MassManagementModalType = {
    type: typeof MODAL_MASS_MANAGEMENT;
};
export type PackConflictModalType = {
    type: typeof MODAL_PACK_CONFLICT;
    pack: PackType;
    conflicts: ExtraType[] | PackType[];
    selectedConflicts: ExtraType[] | PackType[];
    isConflictBetweenPackExtras: boolean;
};

export type ServiceProductConflictModalType = {
    type: typeof MODAL_SERVICE_PRODUCT_CONFLICT;
    serviceProduct: ServiceProductType;
    conflicts: ServiceProductType[];
};

export type TradeInModalType = {
    type: typeof MODAL_TRADEIN;
};
export type WinterWheelsModalType = {
    type: typeof MODAL_WINTER_WHEELS;
};

export type FinanceToggleModalType = {
    type: typeof MODAL_FINANCE_TOGGLE;
};

export type ModalProaceDimensionsType = {
    type: typeof MODAL_PROACE;
    dimensions: {
        capacity: ModelFilterDimensionType[];
        dimensions: ModelFilterDimensionType[];
        bootImage: {
            default: string;
            set: string;
        };
    };
};

export type ModalFilterDebugType = {
    type: typeof MODAL_LCV_DEBUG;
};

export type ModalExtraOnlyPackSingleType = {
    type: typeof MODAL_EXTRA_ONLY_PACK_SINGLE;
    extra: ExtraType;
};

export type ModalExtraOnlyPackMultipleType = {
    type: typeof MODAL_EXTRA_ONLY_PACK_MULTIPLE;
    extra: ExtraType;
};

export type BnbModalsType =
    | GradeEquipmentModalType
    | GradeInteriorModalType
    | EngineDetailsModalType
    | FinanceModalType
    | FinanceCalculatorModalType
    | ConfigCodeModalType
    | TradeInModalType
    | BuyTermsModalType
    | ReserveTermsModalType
    | LeaseTermsModalType
    | WinterWheelsModalType
    | AlternativesETAModalType
    | PackConflictModalType
    | ExtraConflictModalType
    | MassManagementModalType
    | ExitPassiveSummaryModalType
    | DetailedTyreInfoModalType
    | FinanceToggleModalType
    | IntegratedTradeInModalType
    | ServiceProductConflictModalType
    | ModalProaceDimensionsType
    | ModalFilterDebugType
    | RetailerDebugModalType
    | RetailerShowTyCodeModalType
    | ModalExtraOnlyPackSingleType
    | ModalExtraOnlyPackMultipleType;
